import { render } from "./sygnet.vue?vue&type=template&id=20f9c92e&scoped=true"
import script from "./sygnet.vue?vue&type=script&lang=js"
export * from "./sygnet.vue?vue&type=script&lang=js"

import "./sygnet.vue?vue&type=style&index=0&id=20f9c92e&scoped=true&lang=css"

import exportComponent from "/Users/dudgh/git/project/fognet/admin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f9c92e"]])

export default __exports__